<template>
	<el-dialog :visible.sync="visible" title="加入黑名单" width="540px" :before-close="beforeClose" :close-on-click-modal="false">
		<tip
			class="mb-24"
			type="warning"
			content="达人拉黑后将取消达人所有跟进人的跟进关系且进行中(团长分销+达人分销)样品订单/合作进度自动关闭，新达人运营无法认领达人也无法从团长渠道给达人寄样；"
		></tip>
		<div class="mt-24 mb-24 p-16 yx-background font-h4-regular radius-4">
			<div>
				<span class="yx-color-danger">*</span>
				<span class="yx-color-text-primary ml-2">拉黑原因</span>
			</div>
			<div class="mt-8">
				<el-input
					v-model="form.blockReason"
					:rows="3"
					type="textarea"
					maxlength="100"
					minlength="0"
					show-word-limit
					placeholder="请输入拉黑原因，拉黑原因将同步更新到达人跟进记录"
				></el-input>
			</div>
		</div>
		<div slot="footer">
			<el-button @click="beforeClose">取 消</el-button>
			<el-button type="primary" @click="confirm" :disabled="!isDisabled">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { batchBlacklistAnchor, blacklistAnchor } from '@/api/talentCRM';
export default {
	computed: {
		isDisabled({ form }) {
			return form.blockReason;
		},
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {
			visible: false,
			form: {
				blockReason: '',
			},
			type: 'single',
			anchorId: '',
		};
	},
	methods: {
		show(type = 'single', anchorId) {
			this.type = type;
			this.anchorId = anchorId;
			this.visible = true;
		},
		beforeClose() {
			this.form = {
				blockReason: '',
			};
			this.type = 'single';
			this.visible = false;
		},
		async confirm() {
			const {
				type,
				anchorId,
				platformId,
				form: { blockReason },
			} = this;
			let api = {
				single: blacklistAnchor,
				batch: batchBlacklistAnchor,
			};
			let params = {
				single: {
					anchorId,
					platformId,
					blockReason,
				},
				batch: {
					anchorIds: anchorId,
					platformId,
					blockReason,
				},
			};
			await api[type](params[type]);
			this.beforeClose();
			this.$message.success('操作成功！');
			this.$emit('refresh');
		},
	},
};
</script>
